var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"choice-tree"},[_c('ChoiceBranch',{attrs:{"branch":_vm.tree,"value-chain":_vm.field.$model,"show-call-text":_vm.showCallText},on:{"choice":_vm.onChoice}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }